var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2258 9.43637L4.3869 6.64258L3.854 7.56562L8.69291 10.3593L9.2258 9.43637Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2258 3.56399L4.3869 6.35778L3.854 5.43473L8.69291 2.64099L9.2258 3.56399Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6568 4.47632C11.8928 4.47632 12.8949 3.47426 12.8949 2.23816C12.8949 1.00206 11.8928 0 10.6568 0C9.42068 0 8.41863 1.00206 8.41863 2.23816C8.41863 3.47426 9.42068 4.47632 10.6568 4.47632ZM4.58179 6.49705C4.58179 7.73315 3.57973 8.73521 2.34363 8.73521C1.10752 8.73521 0.105469 7.73315 0.105469 6.49705C0.105469 5.26094 1.10752 4.25891 2.34363 4.25891C3.57973 4.25891 4.58179 5.26094 4.58179 6.49705ZM12.8949 10.7618C12.8949 9.52574 11.8928 8.52368 10.6568 8.52368C9.42068 8.52368 8.41863 9.52574 8.41863 10.7618C8.41863 11.9979 9.42068 13 10.6568 13C11.8928 13 12.8949 11.9979 12.8949 10.7618Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7282a21787e71c0a291b6613bf08ca71.svg";
export { ForwardRef as ReactComponent };